import { ArrowRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { Reveal } from "@/components/Reveal";

export const Collaboration = () => {
    const { t } = useSite();
    return (
        <section id="collaboration" data-testid="collaboration-section" className="mesh-dark relative z-10 -mt-8 overflow-hidden rounded-t-[2rem] text-white sm:rounded-t-[3rem]">
            <div className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 sm:py-32 lg:px-12 lg:py-40">
                <Reveal>
                    <h2 className="headline-section max-w-[18ch] font-display font-semibold" data-testid="collaboration-heading">
                        {t.collaboration.heading}
                    </h2>
                </Reveal>

                <div className="mt-16 grid grid-cols-1 border-t border-white/10 sm:grid-cols-2 lg:mt-20 xl:grid-cols-4">
                    {t.collaboration.areas.map((a, i) => (
                        <Reveal key={a.name} delay={i * 0.08} className="border-b border-white/10 sm:border-r xl:border-b-0">
                            <article data-testid={`collaboration-area-${i}`} className="flex h-full flex-col p-6 sm:p-8">
                                <span aria-hidden="true" className="font-display text-sm font-medium tracking-[0.2em] text-chitta-sky">
                                    0{i + 1}
                                </span>
                                <h3 className="mt-6 font-display text-lg font-semibold uppercase leading-snug tracking-[0.08em]">
                                    {a.name}
                                </h3>
                                <p className="mt-4 text-base leading-[1.8] text-white/70">{a.desc}</p>
                            </article>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.1} className="mt-14">
                    <button
                        type="button"
                        data-testid="collaboration-cta"
                        onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" })}
                        className="group inline-flex min-h-[52px] items-center gap-3 bg-chitta-sky px-8 font-display text-sm font-semibold lowercase tracking-[0.1em] text-chitta-deep transition-colors duration-200 hover:bg-white"
                    >
                        {t.collaboration.cta}
                        <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
                    </button>
                </Reveal>
            </div>
        </section>
    );
};
